// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"draft"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 17C13.8638 17 15.4299 15.7252 15.874 14H22V21H2V14H8.12602C8.57006 15.7252 10.1362 17 12 17Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12 17C13.8638 17 15.4299 15.7252 15.874 14L20 14V3H4V14L8.12602 14C8.57006 15.7252 10.1362 17 12 17Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 14V3H20V14M15.874 14C15.4299 15.7252 13.8638 17 12 17C10.1362 17 8.57006 15.7252 8.12602 14H2V21H22V14H15.874Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 7H16M8 11H12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const DraftIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'draft',
    ref,
    icon: element,
  },
));

DraftIcon.displayName = 'DraftIcon';

export default DraftIcon;
